export const INPUT_MANAGEMENT_NOM_DAY_MODEL_LIST = 'INPUT_MANAGEMENT_NOM_DAY_MODEL_LIST'
export const INPUT_MANAGEMENT_NOM_DAY_SEARCH = 'INPUT_MANAGEMENT_NOM_DAY_SEARCH'
export const INPUT_MANAGEMENT_NOM_DAY_PAGINATION = 'INPUT_MANAGEMENT_NOM_DAY_PAGINATION'
export const INPUT_MANAGEMENT_NOM_DAY_DROP_DOWN_SEARCH_TYPE = 'INPUT_MANAGEMENT_NOM_DAY_DROP_DOWN_SEARCH_TYPE'
